// SEO slug config — every slug maps to a dedicated crawlable landing page
// URL: /jodoh/<slug>. Kept in one place so App.js, SeoLandingPage.js, and
// scripts/generate_sitemap.js all read the same source of truth.

export const CATEGORIES = [
  { slug: 'buddhist',          label: 'Buddhist',          category: 'Buddhist Match'  },
  { slug: 'katolik',           label: 'Katolik',           category: 'Katholik Match'  },
  { slug: 'kristen',           label: 'Kristen',           category: 'Christian Match' },
  { slug: 'christian',         label: 'Christian',         category: 'Christian Match' },
  { slug: 'islam',             label: 'Islam',             category: 'Islam Match'     },
  { slug: 'muslim',            label: 'Muslim',            category: 'Islam Match'     },
  { slug: 'hindu',             label: 'Hindu',             category: 'Hindu Match'     },
  { slug: 'konghucu',          label: 'Konghucu',          category: 'Konghucu Match'  },
  { slug: 'tenglang',          label: 'Tenglang',          category: 'Tenglang Match'  },
  { slug: 'chinese-indonesia', label: 'Chinese Indonesia', category: 'Tenglang Match'  },
  { slug: 'usa',               label: 'USA',               category: 'USA Match'       },
  { slug: 'australia',         label: 'Australia',         category: 'Australia Match' },
  { slug: 'korea',             label: 'Korea',             category: 'Korea Match'     },
  { slug: 'taiwan',            label: 'Taiwan',            category: 'Taiwan Match'    },
  { slug: 'singapore',         label: 'Singapore',         category: 'Singapore Match' },
  { slug: 'japan',             label: 'Japan',             category: 'Japan Match'     },
  { slug: 'china',             label: 'China',             category: 'China Match'     },
  { slug: 'pik',               label: 'PIK',               category: 'PIK Match'       },
  { slug: 'bsd',               label: 'BSD',               category: 'BSD Match'       },
  { slug: 'uwiw',              label: 'Uwiw (UI)',         category: 'Uwiw Match'      },
  { slug: 'pelangi',           label: 'Pelangi (LGBTQ+)',  category: 'Pelangi Match'   },
];

export const CITIES = [
  { slug: 'jakarta',      label: 'Jakarta' },
  { slug: 'surabaya',     label: 'Surabaya' },
  { slug: 'bandung',      label: 'Bandung' },
  { slug: 'medan',        label: 'Medan' },
  { slug: 'semarang',     label: 'Semarang' },
  { slug: 'makassar',     label: 'Makassar' },
  { slug: 'kupang',       label: 'Kupang' },
  { slug: 'ntt',          label: 'NTT (Nusa Tenggara Timur)' },
  { slug: 'bali',         label: 'Bali' },
  { slug: 'denpasar',     label: 'Denpasar' },
  { slug: 'yogyakarta',   label: 'Yogyakarta' },
  { slug: 'jogja',        label: 'Jogja' },
  { slug: 'batam',        label: 'Batam' },
  { slug: 'palembang',    label: 'Palembang' },
  { slug: 'manado',       label: 'Manado' },
  { slug: 'balikpapan',   label: 'Balikpapan' },
  { slug: 'pontianak',    label: 'Pontianak' },
  { slug: 'pekanbaru',    label: 'Pekanbaru' },
  { slug: 'bogor',        label: 'Bogor' },
  { slug: 'tangerang',    label: 'Tangerang' },
  { slug: 'bekasi',       label: 'Bekasi' },
  { slug: 'depok',        label: 'Depok' },
  { slug: 'solo',         label: 'Solo (Surakarta)' },
  { slug: 'malang',       label: 'Malang' },
  { slug: 'lampung',      label: 'Lampung' },
  { slug: 'aceh',         label: 'Aceh' },
  { slug: 'papua',        label: 'Papua' },
  { slug: 'jayapura',     label: 'Jayapura' },
  { slug: 'ambon',        label: 'Ambon (Maluku)' },
  { slug: 'kalimantan',   label: 'Kalimantan' },
  { slug: 'sumatra',      label: 'Sumatra' },
  { slug: 'sulawesi',     label: 'Sulawesi' },
];

// Curated combinations that get their own sitemap entry (top targets).
// A slug can be a plain category, a plain city, or `<category>-di-<city>`.
export const COMBO_TARGETS = [
  'buddhist-di-jakarta', 'buddhist-di-surabaya', 'buddhist-di-medan', 'buddhist-di-bandung',
  'katolik-di-jakarta', 'katolik-di-surabaya', 'katolik-di-kupang', 'katolik-di-ntt', 'katolik-di-manado',
  'kristen-di-jakarta', 'kristen-di-medan', 'kristen-di-manado', 'kristen-di-kupang',
  'islam-di-jakarta', 'islam-di-bandung', 'islam-di-surabaya',
  'hindu-di-bali', 'hindu-di-denpasar', 'hindu-di-jakarta',
  'tenglang-di-jakarta', 'tenglang-di-medan', 'tenglang-di-pik', 'tenglang-di-bsd',
  'chinese-indonesia-di-jakarta', 'chinese-indonesia-di-medan', 'chinese-indonesia-di-surabaya',
];

export function findSlug(slug) {
  if (!slug) return null;
  const s = slug.toLowerCase();
  // Combo: <cat>-di-<city>
  const m = s.match(/^([a-z-]+)-di-([a-z-]+)$/);
  if (m) {
    const cat = CATEGORIES.find(c => c.slug === m[1]);
    const city = CITIES.find(c => c.slug === m[2]);
    if (cat && city) return { kind: 'combo', category: cat, city };
  }
  const cat = CATEGORIES.find(c => c.slug === s);
  if (cat) return { kind: 'category', category: cat };
  const city = CITIES.find(c => c.slug === s);
  if (city) return { kind: 'city', city };
  return null;
}
